import { InjectionToken } from "@angular/core";

export const HostToken = new InjectionToken("HostToken");
